import script from "./new.vue?vue&type=script&setup=true&lang=ts"
export * from "./new.vue?vue&type=script&setup=true&lang=ts"

import "./new.vue?vue&type=style&index=0&id=325c5cd2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-325c5cd2"]])

export default __exports__